import { EventEmitter, Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";

import {
  ViewService,
  SearchParams,
  ProcessCategory,
  ProcessCategoryService,
  CheckboxRenderer,
  CheckboxEditor,
  DeleteRowRenderer,
  AddRowHeader,
  ListViewDelegate,
  capitalizeFirstLetter,
} from "../common";

@Component({
  selector: "process-categories-view",
  templateUrl: "./auxiliarylist-view.html",
  standalone: false,
})
export class ProcessCategoriesView implements ListViewDelegate<ProcessCategory> {
  errorMsg: string;
  public refresh: EventEmitter<void> = new EventEmitter<void>();
  public entity: ProcessCategory;
  public sourceColumns;
  public sourceComponents;
  gridKeyColumn: string = "name";

  constructor(
    public route: ActivatedRoute,
    public viewService: ViewService,
    public dataService: ProcessCategoryService
  ) {
    viewService.setViewData({
      pageTitle: "Process Categories",
      link: {},
      breadcrumbs: false,
    });
    this.sourceComponents = {
      chkBoxRenderer: CheckboxRenderer,
      chkBoxEditor: CheckboxEditor,
      deleteRow: DeleteRowRenderer,
      addRow: AddRowHeader,
    };
    this.sourceColumns = [
      {
        headerComponent: "addRow",
        headerComponentParams: { selectColumn: this.gridKeyColumn },
        cellRenderer: "deleteRow",
        minWidth: 100,
        sortable: false,
        filter: false,
        editable: false,
      },
      {
        headerName: capitalizeFirstLetter(this.gridKeyColumn),
        field: this.gridKeyColumn,
        minWidth: 400,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Disposable Method",
        field: "disposableMethod",
        minWidth: 200,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Cost Factor",
        field: "costFactor",
        minWidth: 200,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Active",
        field: "active",
        minWidth: 100,
        filter: false,
        sortingOrder: ["asc", "desc"],
        cellRenderer: "chkBoxRenderer",
        cellEditor: "chkBoxEditor",
      },
    ];
  }

  performSearch(searchParams: SearchParams): Observable<ProcessCategory[]> {
    return this.dataService.all(searchParams);
  }

  save(entity: ProcessCategory) {
    this.dataService.save(entity).subscribe(
      (en) => {
        this.errorMsg = null;
        this.refreshView();
      },
      (error) => {
        this.errorMsg = error;
        this.refreshView();
      }
    );
  }

  remove(entity: ProcessCategory) {
    if (window.confirm(`Are you sure you want to remove '${entity[this.gridKeyColumn]}'?`)) {
      this.dataService.remove(entity.id).subscribe((x) => {
        this.errorMsg = null;
        this.refreshView();
      });
    }
  }

  refreshView() {
    this.refresh.emit();
  }
}
